import { toast } from "sonner";
import { create } from "zustand";

export interface ConfirmationModalStore {
  isOpen: boolean;
  files: string[];
  dependencies: string[];
  isProcessing: boolean;
  onConfirm: (() => Promise<void>) | null;
  onReject: () => void;
  showModal: (
    files: string[],
    dependencies: string[],
    action: () => Promise<void>,
  ) => Promise<boolean>;
  hideModal: () => void;
}

export const useConfirmationModalStore = create<ConfirmationModalStore>(
  (set, get) => ({
    isOpen: false,
    files: [],
    dependencies: [],
    isProcessing: false,
    onConfirm: null,
    onReject: () => {},
    showModal: async (files, dependencies, action) => {
      return new Promise((resolve) => {
        set({
          isOpen: true,
          files,
          dependencies,
          onConfirm: async () => {
            if (get().isProcessing) return;
            set({ isProcessing: true });
            let success = false;
            try {
              await action();
              success = true;
              toast.success("Dependencies installed successfully");
            } catch (error) {
              success = false;
              toast.error("Error installing dependencies");
            } finally {
              set({
                isProcessing: false,
                isOpen: false,
                files: [],
                dependencies: [],
              });
              resolve(success);
            }
          },
          onReject: () => {
            set({ isOpen: false, files: [], dependencies: [] });
            resolve(false);
          },
        });
      });
    },
    hideModal: () => {
      set({ isOpen: false, files: [], dependencies: [], isProcessing: false });
    },
  }),
);

export const showConfirmationModal = async (
  files: string[],
  dependencies: string[],
  action: () => Promise<void>,
) => {
  return useConfirmationModalStore
    .getState()
    .showModal(files, dependencies, action);
};
